export const CUSTOMER_ID_STORAGE = 'CUSTOMER_ID';
export const SMARTCARD_NUMBER_STORAGE = 'SMARTCARD_NUMBER';
export const FIRST_NAME_STORAGE = 'FIRST_NAME_STORAGE';
export const LAST_NAME_STORAGE = 'LAST_NAME_STORAGE';

export const setCustomerId = (value: string): void => {
  localStorage.setItem(CUSTOMER_ID_STORAGE, value);
};

export const getCustomerId = (): string => {
  return localStorage.getItem(CUSTOMER_ID_STORAGE) || '';
};

export const setSmartCardNumber = (value: string): void => {
  localStorage.setItem(SMARTCARD_NUMBER_STORAGE, value);
};

export const getSmartCardNumber = (): string => {
  return localStorage.getItem(SMARTCARD_NUMBER_STORAGE) || '';
};

export const setFirstName = (value: string): void => {
  localStorage.setItem(FIRST_NAME_STORAGE, value);
};

export const getFirstName = (): string => {
  return localStorage.getItem(FIRST_NAME_STORAGE) || '';
};

export const setLastName = (value: string): void => {
  localStorage.setItem(LAST_NAME_STORAGE, value);
};

export const getLastName = (): string => {
  return localStorage.getItem(LAST_NAME_STORAGE) || '';
};
